import React from "react";
import { useAppConfig } from "@/appConfig";

const AppLogo = ({ type = "logoV1", ...props }) => {
  const { tenant } = useAppConfig();
  const logos = tenant?.assets?.logos || {};
  const logoProps = tenant?.assets?.logoProps || {};

  const src = logos[type];

  return <img src={src} alt={type} {...logoProps} {...props} />;
};

export default AppLogo;
